import { render } from "./IconAdvertising.vue?vue&type=template&id=1ac740c5"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconAdvertising.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ac740c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ac740c5', __exports__)) {
    api.reload('1ac740c5', __exports__)
  }
  
  module.hot.accept("./IconAdvertising.vue?vue&type=template&id=1ac740c5", () => {
    api.rerender('1ac740c5', render)
  })

}


export default __exports__